<template><WdsText :text /></template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import useDate from '@/composables/useDate'
import { JobEndTimeframe } from '@/gql/graphql'
import { endDateTimeframeOptions } from '@/components/Job/constants'

const JobEndDateColumn = graphql(`
  fragment JobEndDateColumn on Job {
    id
    endDate
    endDateTimeframe
  }
`)

const props = defineProps<{
  row: FragmentType<typeof JobEndDateColumn>
}>()
const column = computed(() => useFragment(JobEndDateColumn, props.row))

const lookupText = endDateTimeframeOptions.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {},
)

const text = computed(() => {
  const { date, isValid } = useDate(column.value.endDate)
  if (column.value.endDateTimeframe) {
    switch (column.value.endDateTimeframe) {
      case JobEndTimeframe.Open:
        return $t('Unspecified')
      case JobEndTimeframe.OnDate:
        if (isValid.value && !!date.value) {
          return $t('Until :date', { date: date.value })
        }
        return $t('Until unspecified date')
      default:
        return lookupText[column.value.endDateTimeframe]
    }
  }

  return '-'
})
</script>

<style lang="scss"></style>
